<script setup lang="ts">
import { computed, ref, reactive, onMounted } from 'vue'
// import { ElButton } from '@windplug/vue-primitives'
// import { outlineIcons } from '@/primitives'
import { ElIcon, IconNames } from '@/components/icons'

import { useClickOutside } from '@builtwithjavascript/use-click-outside'

interface TProps {
  lcid: string
  title: string
  imageSrc: string
  imageAlt: string
}

const props = withDefaults(defineProps<TProps>(), {
  lcid: 'en',
  title: '',
  imageSrc: '',
  imageAlt: '',
})

const emits = defineEmits<{
  (e: 'close'): any
}>()

const { translate } = useLocalization()

const localState = reactive({
  title: props.title,
})

const refDialogPanel = ref()

const computedInnerDivCss = computed(() => {
  const result = [
    'flex flex-col items-center justify-start sm:justify-center mx-auto min-h-screen text-center',
  ]
  result.push('bg-modaloverlay bg-opacity-75 backdrop-opacity-75')
  return result.join(' ').trim()
})

const computedModalPanelCss = computed(() => {
  const result = ['relative inline-block align-bottom rounded-lg overflow-hidden shadow-xl text-left']
  result.push('bg-modal bg-opacity-100 backdrop-opacity-100 content-modal')
  result.push('sm:my-8 sm:align-middle')
  //result.push('p-4')
  const maxWidthCss = '' //(props.overrideMaxWidthCss || '').trim()
  if (maxWidthCss.length > 0) {
    result.push(maxWidthCss)
  } else {
    result.push('sm:max-w-[90dvw] max-h-[90dvh]')
  }

  return result.join(' ').trim()
})

const onCloseClicked = async () => {
  emits('close')
}

onMounted(() => {
  useClickOutside(refDialogPanel.value as any, () => {
    emits('close')
  })
})
</script>

<template>
  <ClientOnly>
    <div
      class="fixed z-50 inset-0 h-screen overflow-y-auto transform transition-all"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="`dialog-title`"
      :aria-describedby="`dialog-title`"
    >
      <div :class="computedInnerDivCss">
        <div ref="refDialogPanel" :data-testid="`dialog-panel`" :class="computedModalPanelCss">
          <div class="relative">
            <div
              class="absolute right-2 top-2 flex flex-col items-center justify-center border border-primary rounded-full size-5 cursor-pointer bg-card text-primary hover:bg-primary hover:content-primary transition-colors duration-150"
            >
              <ElIcon
                :name="IconNames.xmark"
                sizeCss="size-4"
                fill="currentColor"
                stroke="currentColor"
                @click="onCloseClicked"
              />
            </div>

            <div class="w-fit h-fit p-4">
              <picture v-if="imageSrc">
                <source :srcset="imageSrc.replace('.png', '.webp')" type="image/webp" />
                <source :srcset="imageSrc" type="image/png" />
                <img
                  :src="imageSrc?.replace('.png', '.webp')"
                  :alt="imageAlt"
                  class="max-w-full max-h-full sm:max-w-[48rem] sm:max-h-[48rem] rounded-md shadow-xl"
                />
              </picture>
            </div>

            <div class="w-full flex flex-row justify-center mb-4">
              <button
                :data-testid="`what-is-new_btn-close`"
                @click.prevent="onCloseClicked"
                class="min-w-32 rounded-md bg-primary content-primary px-3 py-2 text-sm font-semibold shadow-sm hover:bg-primary"
                aria-expanded="false"
              >
                <span>{{ translate('labels.close') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>
